import { VideoItem } from "@/utils/types/video-item.type";
import { Socket } from "socket.io-client";
import toast from "react-hot-toast";

const handleDislike = (
  video: VideoItem,
  user: string | null,
  playerRef: React.MutableRefObject<{
    internalPlayer: {
      playVideo: () => void;
      pauseVideo: () => void;
      setVolume: (value: number) => void;
      getPlayerState: () => Promise<number>;
    };
  } | null>,
  serverEndpoint: string | undefined,
  socketRef: React.MutableRefObject<Socket | null>
) => {
  if (user) {
    if (playerRef && playerRef.current) {
      if (serverEndpoint) {
        if (socketRef && socketRef.current) {
          socketRef.current.emit("addDislike", video, user);
        }
      }
    }
  } else {
    toast.error(`You are not authorized!`);
  }
};

export default handleDislike;
